









import { Component } from 'vue-property-decorator'

import Field from './Field.vue'
import TrueFalse from '@/components/common/TrueFalse.vue'

@Component({
  components: { TrueFalse }
})
export default class FieldBoolean extends Field {

  get currentValue() {

    const boolVal = this.field.value
    let boolDropVal = this.field.dropoffValue || this.field.value

    if (this.field.dropoffValue === false) {
      boolDropVal = false
    }
    return this.isSecond ? (this.field.dropoff ? boolDropVal : boolVal) : boolVal
  }

  beforeUpdateField(field, value) {
    this.updateField(field, value.toString())
  }
}
